import { __assign } from 'tslib';
import { ThirdPartyAdapterFactory } from './thirdparty-adapter-factory.esm.js';

var TypeaheadLocationType;
(function (TypeaheadLocationType) {
    TypeaheadLocationType["HOTEL"] = "HOTEL";
    TypeaheadLocationType["AIRPORT"] = "AIRPORT";
    TypeaheadLocationType["MULTICITY"] = "MULTICITY";
    TypeaheadLocationType["POI"] = "POI";
    TypeaheadLocationType["METROCODE"] = "METROCODE";
    TypeaheadLocationType["METROSTATION"] = "METROSTATION";
    TypeaheadLocationType["TRAINSTATION"] = "TRAINSTATION";
    TypeaheadLocationType["ADDRESS"] = "ADDRESS";
    TypeaheadLocationType["NEIGHBORHOOD"] = "NEIGHBORHOOD";
    TypeaheadLocationType["CURRENT_LOCATION"] = "CURRENT_LOCATION";
})(TypeaheadLocationType || (TypeaheadLocationType = {}));
var EssFeatures;
(function (EssFeatures) {
    EssFeatures["GOOGLE"] = "google";
    EssFeatures["CONSISTENT_DISPLAY"] = "consistent_display";
})(EssFeatures || (EssFeatures = {}));
var ESSAdapter = /** @class */ (function () {
    function ESSAdapter(config) {
        this.viewSize = 0;
        this.isGeoLocationAllowed = true;
        this.config = config;
        this.config.getDevice = this.getDevice;
        if (config.essLogger) {
            this.initLoggers(config.essLogger);
        }
    }
    ESSAdapter.prototype.setTypeaheadCategories = function () {
        var formatText = this.l10n.formatText;
        this.ESSCategories = {
            ADDRESS: formatText('typeahead.ess.address'),
            AIRPORT: formatText('typeahead.ess.airport'),
            ATTRACTION: formatText('typeahead.ess.attraction'),
            CITY: formatText('typeahead.ess.city'),
            HOTEL: formatText('typeahead.ess.hotel'),
            METROCODE: formatText('typeahead.ess.city'),
            METROSTATION: formatText('typeahead.ess.metroStation'),
            MULTICITY: formatText('typeahead.ess.city'),
            MULTIREGION: formatText('typeahead.ess.city'),
            NEIGHBORHOOD: formatText('typeahead.ess.city'),
            POI: formatText('typeahead.ess.attraction'),
            TRAINSTATION: formatText('typeahead.ess.trainStation')
        };
    };
    ESSAdapter.prototype.getTypeaheadCategories = function () {
        return this.ESSCategories;
    };
    ESSAdapter.prototype.addToESSCategories = function (newCategory) {
        this.ESSCategories = __assign(__assign({}, this.ESSCategories), newCategory);
    };
    ESSAdapter.prototype.setL10n = function (l10n) {
        this.l10n = l10n;
    };
    ESSAdapter.prototype.initLoggers = function (logger) {
        var metadata = __assign({}, this.config);
        delete metadata.essLogger; // Remove unwanted field which causes circular dependency
        logger.initLogger(metadata);
    };
    ESSAdapter.prototype.constructURL = function (query, makeAltDestCall) {
        var _this = this;
        var domain = this.config.domain ? this.config.domain : '';
        domain = domain.endsWith('/') ? domain : "".concat(domain, "/");
        if (domain.endsWith('/')) {
            domain = domain.slice(0, -1);
        }
        var getBaseURL = function () {
            switch (_this.config.domainId) {
                case 'AIRLINE':
                    return "".concat(domain, "/api/v2/suggest");
                default:
                    return "".concat(domain, "/api/v4/typeahead");
            }
        };
        var baseURL = getBaseURL();
        var URLParams = function (params) {
            return Object.entries(params)
                .map(function (_a) {
                var key = _a[0], val = _a[1];
                return "".concat(key, "=").concat(encodeURIComponent(val));
            })
                .join('&');
        };
        if (typeof this.config.browser === 'undefined' || this.config.browser === null) {
            this.config.browser = this.getBrowser(window.navigator.userAgent);
        }
        if (typeof this.config.device === 'undefined' || this.config.device === null) {
            this.config.device = this.getDevice(window.navigator.userAgent);
        }
        if (this.config.domainId === 'AIRLINE') {
            var configV2 = {
                domainId: this.config.domainId,
                lob: this.config.lob,
                maxResults: this.config.maxResults,
                siteid: this.config.siteId,
                locale: this.config.locale
            };
            return "".concat(baseURL, "?query=").concat(query, "&").concat(URLParams(configV2));
        }
        var config = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ browser: this.config.browser, client: this.config.client, dest: this.config.dest, device: this.config.device, expuserid: this.config.expuserid ? this.config.expuserid : -1, features: this.config.features, format: 'json', guid: this.config.guid, lob: this.config.lob, locale: this.config.locale, maxresults: this.config.maxResults, personalize: this.config.personalize ? this.config.personalize : false }, (this.config.regionId ? { rid: this.config.regionId } : {})), { regiontype: this.config.regionType, siteid: this.config.siteId }), (this.config.packageType ? { pt: this.config.packageType } : {})), (this.config.latLong ? { latlong: this.config.latLong } : {})), (this.config.lastSearchRegionId ? { lsrid: this.config.lastSearchRegionId } : {})), (this.config.lastSearchTimestamp ? { lstime: this.config.lastSearchTimestamp } : {})), (this.config.lastSearchLatLong ? { lslatlong: this.config.lastSearchLatLong } : {})), (this.config.lastSearchElapseTime ? { lsetime: this.config.lastSearchElapseTime } : {})), (this.config.googleApiKey ? { googleApiKey: this.config.googleApiKey } : {})), (this.config.alternate && !!makeAltDestCall ? { alternate: true } : {})), (this.config.debounceVariant ? { ab: this.config.debounceVariant } : {})), (this.config.trending ? { trending: this.config.trending } : {})), (this.config.alternateSecondVariant ? { alternateSecondVariant: this.config.alternateSecondVariant } : {})), (this.config.drivable ? { drivable: this.config.drivable } : {}));
        var url = query === '' ? "".concat(baseURL, "/?").concat(URLParams(config)) : "".concat(baseURL, "/").concat(query, "?").concat(URLParams(config));
        return url;
    };
    ESSAdapter.prototype.fetchResponse = function (term, makeAltDestCall) {
        var _this = this;
        var personalize = this.config && this.config.personalize;
        if ((term === '' && personalize) || term !== '') {
            if (this.config.essLogger) {
                this.config.essLogger.logTypeaheadRequest(term);
            }
            return fetch(this.constructURL(term, makeAltDestCall), {
                method: this.config.domainId === 'AIRLINE' ? 'POST' : 'GET'
            }).then(function (response) {
                if (_this.config.essLogger) {
                    _this.config.essLogger.logResponse(response);
                }
                return response.json();
            });
        }
        return Promise.resolve([]);
    };
    ESSAdapter.prototype.fetchResults = function (term, makeAltDestCall) {
        var _this = this;
        if (this.config.essLogger) {
            // This is because the control config is being overriden by variant and we don't want that
            this.config.essLogger.initLogger(this.config);
        }
        var searchTerm = makeAltDestCall ? '' : term;
        return this.fetchResponse(searchTerm, makeAltDestCall)
            .then(function (json) { return _this.handleEssResponse(json); })
            .then(function (json) { return _this.logResponse(json); })
            .then(function (json) { return _this.adaptResponseToTypeaheadResults(json, searchTerm, _this.config.historyDetail); })
            .then(function (json) { return _this.categorizeOnFocusResponse(json, makeAltDestCall); });
    };
    ESSAdapter.prototype.fetchRecentSearchResults = function () {
        return this.fetchResults('');
    };
    ESSAdapter.prototype.fetchAlternativeResults = function (term) {
        return this.fetchResults(term, this.config.alternate);
    };
    ESSAdapter.prototype.fetchResultsCategorized = function (term) {
        var _this = this;
        if (this.config.essLogger) {
            // This is because the control config is being overriden by variant and we don't want that
            this.config.essLogger.initLogger(this.config);
        }
        return this.fetchResponse(term)
            .then(function (json) { return _this.handleEssResponse(json); })
            .then(function (json) { return _this.logResponse(json); })
            .then(function (json) { return _this.adaptResponseToTypeaheadResults(json, term, _this.config.historyDetail); })
            .then(function (json) { return _this.categorizeResponse(json); });
    };
    ESSAdapter.prototype.fetchRecentSearchResultsCategorized = function () {
        return this.fetchResultsCategorized('');
    };
    ESSAdapter.prototype.categorizeResponse = function (typeaheadResults) {
        var _this = this;
        var resultsByCategory = new Map();
        var finalResults = [];
        var trueIndex = 0;
        if (typeaheadResults && typeaheadResults.length > 0) {
            // Creating categories and inserting to a map
            typeaheadResults.forEach(function (element) {
                var _a;
                var categoryName = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.type) ? _this.ESSCategories[element.data.type] : '';
                if (!resultsByCategory[categoryName]) {
                    resultsByCategory[categoryName] = [];
                }
                resultsByCategory[categoryName].push(element);
            });
            for (var _i = 0, _a = Object.entries(resultsByCategory); _i < _a.length; _i++) {
                var _b = _a[_i], heading = _b[0], results = _b[1];
                // Pushing to an array of CategorizedResults
                // eslint-disable-next-line no-loop-func
                results.forEach(function (typeaheadResult) {
                    // eslint-disable-next-line no-param-reassign
                    typeaheadResult.data.index = trueIndex;
                    // eslint-disable-next-line no-plusplus
                    trueIndex++;
                });
                var resultByCategory = {
                    heading: heading,
                    typeaheadResults: results
                };
                finalResults.push(resultByCategory);
            }
        }
        return finalResults;
    };
    ESSAdapter.prototype.onFocusCategories = function () {
        var formatText = this.l10n.formatText;
        return __assign({ CURRENTLOCATION: '', POPULAR: formatText('typeahead.ess.popular') || 'Explore popular destinations', DRIVABLE: formatText('typeahead.ess.nearby') || 'Explore nearby places' }, (this.config.alternateSecondVariant
            ? {
                USERHISTORY: formatText('typeahead.ess.history') || 'Recent searches',
                ALTERNATE: formatText('typeahead.ess.alternate') || 'People also searched'
            }
            : {
                ALTERNATE: formatText('typeahead.ess.alternate') || 'People also searched',
                USERHISTORY: formatText('typeahead.ess.history') || 'Recent searches'
            }));
    };
    ESSAdapter.prototype.categorizeOnFocusResponse = function (typeaheadResults, makeAltDestCall) {
        if (typeaheadResults && typeaheadResults.length > 0) {
            var element0 = typeaheadResults[0];
            if (element0.data.category === 'ALTERNATE' ||
                element0.data.category === 'CURRENTLOCATION' ||
                element0.data.category === 'POPULAR' ||
                (element0.data.category === 'DRIVABLE' && this.config.drivable) ||
                (element0.data.category === 'USERHISTORY' && this.config.alternate && makeAltDestCall)) {
                var resultsByCategory_1 = new Map();
                var finalResults = [];
                var focusCategories = this.onFocusCategories();
                var trueIndex_1 = 0;
                typeaheadResults.forEach(function (element) {
                    if (element.data.category) {
                        var categoryName = element.data.category;
                        if (!resultsByCategory_1[categoryName]) {
                            resultsByCategory_1[categoryName] = [];
                        }
                        resultsByCategory_1[categoryName].push(element);
                    }
                });
                for (var _i = 0, _a = Object.entries(focusCategories); _i < _a.length; _i++) {
                    var _b = _a[_i], category = _b[0], heading = _b[1];
                    var categorizedResult = resultsByCategory_1[category];
                    if (categorizedResult && categorizedResult.length > 0) {
                        // eslint-disable-next-line no-loop-func
                        categorizedResult.forEach(function (typeaheadResult) {
                            // eslint-disable-next-line no-param-reassign
                            typeaheadResult.data.index = trueIndex_1;
                            // eslint-disable-next-line no-param-reassign
                            typeaheadResult.data.displayType = 'CATEGORIZED';
                            trueIndex_1 += 1;
                        });
                        var resultByCategory = {
                            heading: heading,
                            typeaheadResults: categorizedResult
                        };
                        finalResults.push(resultByCategory);
                    }
                }
                if (makeAltDestCall || this.config.showCurrentLocation) {
                    // Log the typeahead response in the logger with the updated order
                    this.response.sr = finalResults.flatMap(function (categorizedResult) {
                        return categorizedResult.typeaheadResults.map(function (typeaheadResult) { return typeaheadResult.data; });
                    });
                    if (this.config.essLogger) {
                        this.config.essLogger.logTypeaheadResponse(this.response);
                    }
                }
                return finalResults;
            }
        }
        return typeaheadResults;
    };
    ESSAdapter.prototype.logSuggestionShown = function (term) {
        if (this.config.essLogger) {
            this.config.essLogger.logSuggestionShown(term);
        }
    };
    ESSAdapter.prototype.onItemSelection = function (data) {
        var _this = this;
        var _a;
        (_a = this.config.essLogger) === null || _a === void 0 ? void 0 : _a.logSuggestionSelected(data);
        if ((data === null || data === void 0 ? void 0 : data.type) === TypeaheadLocationType.CURRENT_LOCATION) {
            if (this.isGeoLocationAllowed) {
                return this.readCurrentLocation()
                    .then(function (_a) {
                    var _b = _a.coords, latitude = _b.latitude, longitude = _b.longitude;
                    return (__assign(__assign({}, data), { location: { lat: latitude.toFixed(5), long: longitude.toFixed(5) } }));
                })
                    .catch(function (error) {
                    _this.isGeoLocationAllowed = false;
                    throw error;
                });
            }
            var message = this.l10n.formatText('typeahead.currentLocation.blocked.message');
            // eslint-disable-next-line no-alert
            window.alert(message);
            return Promise.reject(message);
        }
        return Promise.resolve(data);
    };
    /*
     * Note: Position is a global TypeScript interface representing the response to the navigator.geolocation call.
     * https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.position.html
     */
    ESSAdapter.prototype.readCurrentLocation = function () {
        return new Promise(function (resolve, reject) {
            window.navigator.geolocation.getCurrentPosition(resolve, reject);
        });
    };
    ESSAdapter.prototype.typeaheadDialogOpened = function (prefill) {
        if (this.config.essLogger) {
            var prefillText = prefill && prefill !== '' ? prefill : undefined;
            this.config.essLogger.logTypeaheadOpen(prefillText);
        }
    };
    ESSAdapter.prototype.logTypeaheadDismiss = function () {
        if (this.config.essLogger) {
            this.config.essLogger.logTypeaheadBlurEvent();
        }
    };
    ESSAdapter.prototype.handleEssResponse = function (json) {
        // eslint-disable-next-line no-param-reassign
        json.sr = json.sr || json.suggestions || [];
        if (!this.thirdPartyFallbackAdapter) {
            this.setThirdPartyAdapter();
        }
        if (this.thirdPartyFallbackAdapter && (json.rc === 'GOOGLE_AUTOCOMPLETE' || json.rc === 'ADDRESS_AUTOCOMPLETE')) {
            return this.thirdPartyFallbackAdapter.fetchResults(json);
        }
        return Promise.resolve(json);
    };
    ESSAdapter.prototype.setThirdPartyAdapter = function () {
        var fallbackAdapterRequested = ThirdPartyAdapterFactory.filterThirdPartyAdapterFromEssConfig(this.config.features.split('|'));
        var fallbackAdapter;
        if (fallbackAdapterRequested.length > 0) {
            fallbackAdapter = ThirdPartyAdapterFactory.getInstance(fallbackAdapterRequested[0], this.config.locale, this.config.googleApiKey);
            this.thirdPartyFallbackAdapter = fallbackAdapter;
        }
    };
    ESSAdapter.prototype.logResponse = function (results) {
        if (this.config.essLogger) {
            this.config.essLogger.logTypeaheadResponse(results);
        }
        this.response = results;
        return Promise.resolve(results);
    };
    ESSAdapter.prototype.adaptResponseToTypeaheadResults = function (results, term, historyDetail) {
        var _this = this;
        var getSubtext = function (category, data) {
            var subtextString;
            if (category === 'USERHISTORY' &&
                historyDetail &&
                typeof _this.l10n !== 'undefined' &&
                data &&
                data.searchDetail &&
                data.searchDetail.startDate &&
                data.searchDetail.endDate &&
                data.searchDetail.lob &&
                !term) {
                var detail = data.searchDetail;
                var _a = _this.l10n, formatDateString = _a.formatDateString, formatText = _a.formatText;
                // `TimezoneOffset` is used to prevent the days being off by one day because of local time conversion
                var checkinDate = new Date(detail.startDate);
                var checkinTimezoneOffset = checkinDate.getTimezoneOffset() * 60000;
                var checkinString = formatDateString(new Date(checkinDate.getTime() + checkinTimezoneOffset), {
                    skeleton: 'MMMd'
                });
                var checkoutDate = new Date(detail.endDate);
                var checkoutTimezoneOffset = checkoutDate.getTimezoneOffset() * 60000;
                var checkoutString = formatDateString(new Date(checkoutDate.getTime() + checkoutTimezoneOffset), {
                    skeleton: 'MMMd'
                });
                // Dates are in milliseconds, so divide by ms/day to get number of days/nights
                var nights = (Number(detail.endDate) - Number(detail.startDate)) / 86400000;
                var nightsString = formatText('datePicker.nightSummary', nights);
                var summaryString = '';
                var rooms = detail.roomCount;
                var lineOfBusiness = detail.lob;
                if (rooms === 1 && lineOfBusiness === 'Lodging') {
                    var travelers = Number(data.searchDetail.totalTravelerCount);
                    summaryString = " | ".concat(formatText('typeahead.recentHistory.roomsTravelers', rooms, travelers));
                    subtextString = "".concat(checkinString, " - ").concat(checkoutString, " | ").concat(nightsString).concat(summaryString);
                }
                else if (rooms > 1) {
                    subtextString = "".concat(checkinString, " - ").concat(checkoutString, " | ").concat(nightsString);
                }
                else {
                    subtextString = "".concat(checkinString, " - ").concat(checkoutString);
                }
            }
            return subtextString;
        };
        var parseDisplayText = function (result) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var primaryText;
            var subtext;
            if (result.type === 'LISTING') {
                primaryText = "<span class='listing-headline'>".concat((_a = result.listingProps) === null || _a === void 0 ? void 0 : _a.headline, "</span>");
                subtext = "<strong>".concat((_b = result.listingProps) === null || _b === void 0 ? void 0 : _b.listingId, "</strong> \u00B7 ").concat((_c = result.listingProps) === null || _c === void 0 ? void 0 : _c.baseLocation);
            }
            else {
                subtext = getSubtext(result.category, result);
                if (_this.config.features.indexOf(EssFeatures.CONSISTENT_DISPLAY) < 0) {
                    primaryText = ((_d = result.regionNames) === null || _d === void 0 ? void 0 : _d.displayName) || ((_e = result.names) === null || _e === void 0 ? void 0 : _e.displayName);
                }
                else {
                    primaryText = "<strong>".concat(((_f = result.regionNames) === null || _f === void 0 ? void 0 : _f.primaryDisplayName) || ((_g = result.names) === null || _g === void 0 ? void 0 : _g.displayName), "</strong>");
                    subtext = subtext || ((_h = result.regionNames) === null || _h === void 0 ? void 0 : _h.secondaryDisplayName) || '';
                }
            }
            return { primaryText: primaryText, subtext: subtext };
        };
        // eslint-disable-next-line max-params
        var getIcon = function (type, subType, isChild, isNearby, category) {
            if (type === 'AIRLINE') {
                return '';
            }
            if (isChild && !isNearby) {
                return 'subdirectory_arrow_right';
            }
            if (category === 'USERHISTORY') {
                return 'history';
            }
            if (_this.config.lob === 'FLIGHTS') {
                return 'lob_flights';
            }
            switch (type) {
                case 'HOTEL':
                    return 'lob_hotels';
                case 'AIRPORT':
                    return 'lob_flights';
                case 'ADDRESS':
                    if (subType === 'RENTALLOCATION') {
                        return 'lob_cars';
                    }
                    return 'place';
                case 'LISTING':
                    return 'home';
                case 'METROSTATION':
                case 'TRAINSTATION':
                    return 'train';
                default:
                    return 'place';
            }
        };
        var generateNewResults = function (newResults, result, index) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var isNearby = (result.hierarchyInfo &&
                result.hierarchyInfo.relation &&
                result.hierarchyInfo.relation.indexOf('nearby') > -1);
            var isChild = (result.hierarchyInfo &&
                result.hierarchyInfo.relation &&
                result.hierarchyInfo.relation.indexOf('child') > -1) || isNearby;
            var _l = parseDisplayText(result), primaryText = _l.primaryText, subtext = _l.subtext;
            var newResult = __assign(__assign({ data: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (result.category ? { category: result.category } : {})), (!term && result.searchDetail ? { searchDetail: result.searchDetail } : {})), (result.userHistoryType ? { userHistoryType: result.userHistoryType } : {})), (((_a = result.ids) === null || _a === void 0 ? void 0 : _a.id) ? { id: result.ids.id } : {})), (result.coordinates
                    ? {
                        location: {
                            lat: result.coordinates.lat,
                            long: result.coordinates.long
                        }
                    }
                    : {})), (result.regionId ? { regionId: result.regionId } : result.gaiaId ? { regionId: result.gaiaId } : {})), (result.cityId ? { cityId: result.cityId } : {})), (result.regionNames ? { regionNames: result.regionNames } : {})), (result.type ? { type: result.type } : {})), (result.subtype ? { subtype: result.subtype } : {})), (result.hotelId ? { selected: result.hotelId } : {})), (result.hierarchyInfo ? { hierarchyInfo: result.hierarchyInfo } : {})), (result.essId
                    ? {
                        essId: {
                            sourceId: result.essId.sourceId,
                            sourceName: result.essId.sourceName
                        }
                    }
                    : {})), { dest: _this.config.dest }), { index: index + 1 }), icon: getIcon(result.type || result.domainId, result.subtype, isChild, isNearby, result.category) }, (isChild ? { isChild: true } : {})), { name: primaryText, subtext: subtext, title: ((_b = result.regionNames) === null || _b === void 0 ? void 0 : _b.lastSearchName) ||
                    ((_c = result.regionNames) === null || _c === void 0 ? void 0 : _c.shortName) ||
                    ((_d = result.regionNames) === null || _d === void 0 ? void 0 : _d.fullName) ||
                    ((_e = result.ids) === null || _e === void 0 ? void 0 : _e.id), value: ((_f = result.regionNames) === null || _f === void 0 ? void 0 : _f.lastSearchName) ||
                    ((_g = result.regionNames) === null || _g === void 0 ? void 0 : _g.shortName) ||
                    ((_h = result.regionNames) === null || _h === void 0 ? void 0 : _h.fullName) ||
                    ((_j = result.names) === null || _j === void 0 ? void 0 : _j.displayName) ||
                    ((_k = result.listingProps) === null || _k === void 0 ? void 0 : _k.listingId) });
            newResults.push(newResult);
            return newResults;
        };
        var baseResults = term === '' && this.shouldShowCurrentLocation() ? [this.getCurrentLocationItem()] : [];
        var adapt = function (json) { var _a, _b; return ((_b = (_a = json.sr) === null || _a === void 0 ? void 0 : _a.reduce) === null || _b === void 0 ? void 0 : _b.call(_a, generateNewResults, baseResults)) || baseResults; };
        return adapt(results);
    };
    /**
     * The Current Location feature is only shown on browsers which support it,
     * even when the showCurrentLocation config is set to true.
     */
    ESSAdapter.prototype.shouldShowCurrentLocation = function () {
        return Boolean(this.config.showCurrentLocation && 'geolocation' in navigator);
    };
    /**
     * The "Current location" result item is not returned by the back-end EGTA/ESS API, it is instead created
     * on the front-end and added to the beginning of the results when needed.
     */
    ESSAdapter.prototype.getCurrentLocationItem = function () {
        var label = this.isGeoLocationAllowed
            ? this.l10n.formatText('typeahead.currentLocation.available.item')
            : this.l10n.formatText('typeahead.currentLocation.blocked.item');
        return {
            data: {
                category: 'CURRENTLOCATION',
                hierarchyInfo: {
                    relation: ['current']
                },
                index: -1,
                enabled: this.isGeoLocationAllowed,
                regionNames: {
                    fullName: 'CurrentLocation'
                },
                type: TypeaheadLocationType.CURRENT_LOCATION
            },
            icon: 'my_location',
            name: label,
            title: label,
            value: label
        };
    };
    ESSAdapter.prototype.getBrowser = function (ua) {
        var tem;
        var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            return 'IE';
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge?)\/(\d+)/);
            if (tem !== null) {
                return tem.slice(1, -1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ');
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        tem = ua.match(/version\/(\d+)/i);
        if (tem !== null) {
            M.splice(1, 1, tem[1]);
        }
        return M[0];
    };
    ESSAdapter.prototype.getDevice = function (ua) {
        if (/iPad|Transformer|ME173X|KOOF|Nook|IMM76D|Nexus 10|Nexus 7|Tablet/i.test(ua) ||
            /HP Slate|PG09410|PG41200|Mediapad|Kindle|Tab|Xoom|TegraNote|SCH-I800/i.test(ua)) {
            return 'Tablet';
        }
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
            return 'Mobile';
        }
        return 'Desktop';
    };
    return ESSAdapter;
}());

export { ESSAdapter, TypeaheadLocationType };
